<aside class="main-sidebar">
  <div class="slimScrollDiv" style="
      overflow: scroll;
      height: 100%;
      position: absolute;
      width: inherit;
    ">
    <section class="sidebar" style="height: auto; overflow: hidden; width: auto;">
      <ul class="sidebar-menu">
        <li class="header">MENU</li>

        <li>
          <a routerLink="/home" routerLinkActive="hover-fixed"> <i class="fa fa-home"></i> <span>Home</span> </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_CADASTRO')">
          <a routerLink="/cadastros" routerLinkActive="hover-fixed">
            <i class="fa fa-save"></i> <span>Cadastros</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_HABILITACAO')">
          <a routerLink="/habilitacao/listar" *ngIf="auth.temPermissao('ROLE_VISUALIZAR_HABILITACAO_TODOS')"
            routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Habilitação</span>
          </a>
          <a class="cursor" (click)="gotoHabilitacao(1)"
            *ngIf="auth.temPermissao('ROLE_VISUALIZAR_HABILITACAO_PARCERIA')" routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Habilitação</span>
          </a>
          <a class="cursor" (click)="gotoHabilitacao(2)"
            *ngIf="auth.temPermissao('ROLE_VISUALIZAR_HABILITACAO_CONVENIO')" routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Habilitação</span>
          </a>
          <a class="cursor" (click)="gotoHabilitacao(3)"
            *ngIf="auth.temPermissao('ROLE_VISUALIZAR_HABILITACAO_INOVACAO')" routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Habilitação</span>
          </a>
        </li>


        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_FINANCEIRO')">
          <a routerLink="/financeiro" routerLinkActive="hover-fixed">
            <i class="fa fa-dollar"></i> <span>Financeiro</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_CONTABILIDADE')">
          <a routerLink="/contabilidade" routerLinkActive="hover-fixed">
            <i class="fa fa-calculator"></i> <span>Contabilidade</span>
          </a>
        </li>

        
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_EDITAL_RECADASTRAMENTO')">
          <a routerLink="/editais-recadastramento" routerLinkActive="hover-fixed">
            <i class="fa  fa-id-card"></i>
            <span>Editais de Recadastramento</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_EDITAL_CREDENCIAMENTO')">
          <a routerLink="/editais-credenciamento" routerLinkActive="hover-fixed">
            <i class="fa  fa-balance-scale"></i>
            <span>Editais de Credenciamento</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_CHAMAMENTO_PUBLICO')">
          <a routerLink="/editais-chamamento/listar" routerLinkActive="hover-fixed">
            <i class="fa fa-legal"></i>
            <span>Editais de Cham. Público</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_EMENDA_PARLAMENTAR')">
          <a routerLink="/emenda-parlamentar" routerLinkActive="hover-fixed">
            <i class="fa fa-suitcase"></i> <span>Emenda Parlamentar</span>
          </a>
        </li>


        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_MODELOS')">
          <a routerLink="/modelo" routerLinkActive="hover-fixed">
            <i class="fa fa-wrench"></i> <span>Modelos</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_TRIBUTOS')">
          <a routerLink="/tributos" routerLinkActive="hover-fixed">
            <i class="fas fa-balance-scale"></i> <span>Tributos</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_FROTA')">
          <a routerLink="/frota" routerLinkActive="hover-fixed">
            <i class="fas fa-car"></i> <span>Frota</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_CONTROLE_INTERNO')">
          <a routerLink="/controle-interno" routerLinkActive="hover-fixed">
            <i class="fa fa-search"></i> <span>Controle Interno</span>
          </a>
        </li>

        <!--
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_PROPOSTA')">
          <a routerLink="/proposta" routerLinkActive="hover-fixed">
            <i class="far fa-folder"></i> <span>Proposta</span>
          </a>
        </li>
        -->

        <li *ngIf="auth.temPermissao('ROLE_MENU_PLANOS_SIG3')">
          <a routerLink="/planos/listar" routerLinkActive="hover-fixed">
            <i class="fa fa-angle-right"></i> <span>Planos de trabalho</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_PROJETOS')">
          <a routerLink="/projetos" routerLinkActive="hover-fixed">
            <i class="fa fa-file-text" aria-hidden="true"></i> <span>Projetos</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_PROJETOS_CONCLUIDOS')">
          <a routerLink="/projetos-concluidos" routerLinkActive="hover-fixed">
            <i class="fas fa-thumbs-up"></i> <span>Projetos Concluídos</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_PENDENCIAS')">
          <a routerLink="/pendencia" routerLinkActive="hover-fixed">
            <i class="fa fa-tasks"></i> <span>Pendências</span>
          </a>
        </li>

        <li>
          <a routerLink="/patrocinio/propostas" *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_PATROCINIO')"
            routerLinkActive="hover-fixed">
            <i class="fa fa-money"></i>
            <span>Patrocínio</span>
          </a>
        </li>

        <li>
          <a routerLink="/pmis/cadastrar" *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_MANIFESTACAO_INT_SOCIAL')"
            routerLinkActive="hover-fixed">
            <i class="far fa-file-alt"></i>
            <span>Manifestação de Int. Social</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_ADMINISTRACAO')">
          <a routerLink="/relatorios" routerLinkActive="hover-fixed">
            <i class="fa fa-bar-chart"></i> <span>Relatórios</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_PERFIL_PERMISSAO')">
          <a class="cursor" routerLinkActive="hover-fixed" routerLink="/perfil-permissao">
            <i class="fa fa-cogs"></i> <span>Perfil / Permissão</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_ADMINISTRACAO')">
          <a routerLink="/administracao/listar" routerLinkActive="hover-fixed">
            <i class="fa fa-briefcase"></i> <span>Administração</span>
          </a>
        </li>

        <li>
          <a routerLink="/tutoriais" routerLinkActive="hover-fixed">
            <i class="fas fa-user-graduate"></i> <span>Tutoriais</span>
          </a>
        </li>

        <!-- ========= Modulo escolar ========= -->

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_EDUCACAO')">
          <a routerLink="/educacao-escolar" routerLinkActive="hover-fixed">
            <i class="fas fa-graduation-cap"></i> <span>Educação</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_ADMINISTRACAO')">
          <a routerLink="/assinador-documentos" routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Assinador Documentos</span>
          </a>
        </li>



        <li>&nbsp;</li>
        <li>&nbsp;</li>
      </ul>
    </section>
  </div>
</aside>
